const actionTypes = {
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  RESCORE: 'RESCORE',
  PERFORM: 'PERFORM',
  DELETE: 'DELETE',
  CHANNELUPDATE: 'CHANNELUPDATE',
  SOFTDELETE: 'SOFTDELETE',
};

export { actionTypes };
